import { Theme } from '@mui/material';

const markerSelected = `
<svg width="44" height="52" viewBox="0 0 44 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_12398_17963)">
<mask id="path-1-inside-1_12398_17963" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.7273 38.6136C33.8798 36.897 40 29.6632 40 21C40 11.0589 31.9411 3 22 3C12.0589 3 4 11.0589 4 21C4 29.6632 10.1202 36.897 18.2727 38.6136L22 47L25.7273 38.6136Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.7273 38.6136C33.8798 36.897 40 29.6632 40 21C40 11.0589 31.9411 3 22 3C12.0589 3 4 11.0589 4 21C4 29.6632 10.1202 36.897 18.2727 38.6136L22 47L25.7273 38.6136Z" fill="#31694B"/>
<path d="M25.7273 38.6136L25.5212 37.6351L25.0211 37.7404L24.8135 38.2075L25.7273 38.6136ZM18.2727 38.6136L19.1865 38.2075L18.9789 37.7404L18.4788 37.6351L18.2727 38.6136ZM22 47L21.0862 47.4061L22 49.4622L22.9138 47.4061L22 47ZM39 21C39 29.1807 33.2205 36.0139 25.5212 37.6351L25.9333 39.5922C34.5392 37.7801 41 30.1457 41 21H39ZM22 4C31.3888 4 39 11.6112 39 21H41C41 10.5066 32.4934 2 22 2V4ZM5 21C5 11.6112 12.6112 4 22 4V2C11.5066 2 3 10.5066 3 21H5ZM18.4788 37.6351C10.7795 36.0139 5 29.1807 5 21H3C3 30.1457 9.46085 37.7801 18.0667 39.5922L18.4788 37.6351ZM22.9138 46.5939L19.1865 38.2075L17.3589 39.0198L21.0862 47.4061L22.9138 46.5939ZM24.8135 38.2075L21.0862 46.5939L22.9138 47.4061L26.6411 39.0198L24.8135 38.2075Z" fill="white" mask="url(#path-1-inside-1_12398_17963)"/>
<g clip-path="url(#clip0_12398_17963)">
<path d="M22 29.98C16.24 23.96 15.32 22 15.32 19.34C15.32 15.76 18.38 12.72 22 12.72C25.62 12.72 28.68 15.76 28.68 19.34C28.68 22 27.76 23.96 22 29.98ZM22 21.74C23.34 21.74 24.42 20.66 24.42 19.32C24.42 17.98 23.34 16.9 22 16.9C20.66 16.9 19.58 17.98 19.58 19.32C19.58 20.66 20.66 21.74 22 21.74Z" fill="white"/>
</g>
</g>
<defs>
<filter id="filter0_d_12398_17963" x="0" y="0" width="44" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_12398_17963"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12398_17963"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12398_17963" result="shape"/>
</filter>
<clipPath id="clip0_12398_17963">
<rect width="24" height="24" fill="white" transform="translate(10 9)"/>
</clipPath>
</defs>
</svg>
`;
const markerUnselected = `
<svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_23380_15269)">
<mask id="path-1-inside-1_23380_15269" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7857 30.4821C27.6785 28.8309 32 23.4201 32 17C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 17C4 23.4201 8.32149 28.8309 14.2143 30.4821L18 39L21.7857 30.4821Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7857 30.4821C27.6785 28.8309 32 23.4201 32 17C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 17C4 23.4201 8.32149 28.8309 14.2143 30.4821L18 39L21.7857 30.4821Z" fill="#161718"/>
<path d="M21.7857 30.4821L21.5159 29.5192L21.0629 29.6462L20.8719 30.076L21.7857 30.4821ZM14.2143 30.4821L15.1281 30.076L14.9371 29.6462L14.4841 29.5192L14.2143 30.4821ZM18 39L17.0862 39.4061L18 41.4622L18.9138 39.4061L18 39ZM31 17C31 22.9601 26.9883 27.9858 21.5159 29.5192L22.0555 31.4451C28.3687 29.676 33 23.8801 33 17H31ZM18 4C25.1797 4 31 9.8203 31 17H33C33 8.71573 26.2843 2 18 2V4ZM5 17C5 9.8203 10.8203 4 18 4V2C9.71573 2 3 8.71573 3 17H5ZM14.4841 29.5192C9.01173 27.9858 5 22.9601 5 17H3C3 23.8801 7.63125 29.676 13.9445 31.4451L14.4841 29.5192ZM18.9138 38.5939L15.1281 30.076L13.3005 30.8883L17.0862 39.4061L18.9138 38.5939ZM20.8719 30.076L17.0862 38.5939L18.9138 39.4061L22.6995 30.8883L20.8719 30.076Z" fill="white" mask="url(#path-1-inside-1_23380_15269)"/>
<g clip-path="url(#clip0_23380_15269)">
<path d="M18 24.683C13.104 19.566 12.322 17.9 12.322 15.639C12.322 12.596 14.923 10.012 18 10.012C21.077 10.012 23.678 12.596 23.678 15.639C23.678 17.9 22.896 19.566 18 24.683ZM18 17.679C19.139 17.679 20.057 16.761 20.057 15.622C20.057 14.483 19.139 13.565 18 13.565C16.861 13.565 15.943 14.483 15.943 15.622C15.943 16.761 16.861 17.679 18 17.679Z" fill="white"/>
</g>
</g>
<defs>
<filter id="filter0_d_23380_15269" x="0" y="0" width="36" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_23380_15269"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23380_15269"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_23380_15269" result="shape"/>
</filter>
<clipPath id="clip0_23380_15269">
<rect width="20" height="20" fill="white" transform="translate(8 7)"/>
</clipPath>
</defs>
</svg>
`;
const markerSelectedDark = `
<svg width="44" height="52" viewBox="0 0 44 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_12398_17968)">
<mask id="path-1-inside-1_12398_17968" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.7273 38.6136C33.8798 36.897 40 29.6632 40 21C40 11.0589 31.9411 3 22 3C12.0589 3 4 11.0589 4 21C4 29.6632 10.1202 36.897 18.2727 38.6136L22 47L25.7273 38.6136Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.7273 38.6136C33.8798 36.897 40 29.6632 40 21C40 11.0589 31.9411 3 22 3C12.0589 3 4 11.0589 4 21C4 29.6632 10.1202 36.897 18.2727 38.6136L22 47L25.7273 38.6136Z" fill="#78FAAE"/>
<path d="M25.7273 38.6136L25.5212 37.6351L25.0211 37.7404L24.8135 38.2075L25.7273 38.6136ZM18.2727 38.6136L19.1865 38.2075L18.9789 37.7404L18.4788 37.6351L18.2727 38.6136ZM22 47L21.0862 47.4061L22 49.4622L22.9138 47.4061L22 47ZM39 21C39 29.1807 33.2205 36.0139 25.5212 37.6351L25.9333 39.5922C34.5392 37.7801 41 30.1457 41 21H39ZM22 4C31.3888 4 39 11.6112 39 21H41C41 10.5066 32.4934 2 22 2V4ZM5 21C5 11.6112 12.6112 4 22 4V2C11.5066 2 3 10.5066 3 21H5ZM18.4788 37.6351C10.7795 36.0139 5 29.1807 5 21H3C3 30.1457 9.46085 37.7801 18.0667 39.5922L18.4788 37.6351ZM22.9138 46.5939L19.1865 38.2075L17.3589 39.0198L21.0862 47.4061L22.9138 46.5939ZM24.8135 38.2075L21.0862 46.5939L22.9138 47.4061L26.6411 39.0198L24.8135 38.2075Z" fill="#161718" mask="url(#path-1-inside-1_12398_17968)"/>
<g clip-path="url(#clip0_12398_17968)">
<path d="M22 29.98C16.24 23.96 15.32 22 15.32 19.34C15.32 15.76 18.38 12.72 22 12.72C25.62 12.72 28.68 15.76 28.68 19.34C28.68 22 27.76 23.96 22 29.98ZM22 21.74C23.34 21.74 24.42 20.66 24.42 19.32C24.42 17.98 23.34 16.9 22 16.9C20.66 16.9 19.58 17.98 19.58 19.32C19.58 20.66 20.66 21.74 22 21.74Z" fill="#161718"/>
</g>
</g>
<defs>
<filter id="filter0_d_12398_17968" x="0" y="0" width="44" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_12398_17968"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12398_17968"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12398_17968" result="shape"/>
</filter>
<clipPath id="clip0_12398_17968">
<rect width="24" height="24" fill="white" transform="translate(10 9)"/>
</clipPath>
</defs>
</svg>
`;
const markerUnselectedDark = `
<svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_23414_15743)">
<mask id="path-1-inside-1_23414_15743" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7857 30.4821C27.6785 28.8309 32 23.4201 32 17C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 17C4 23.4201 8.32149 28.8309 14.2143 30.4821L18 39L21.7857 30.4821Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7857 30.4821C27.6785 28.8309 32 23.4201 32 17C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 17C4 23.4201 8.32149 28.8309 14.2143 30.4821L18 39L21.7857 30.4821Z" fill="white"/>
<path d="M21.7857 30.4821L21.5159 29.5192L21.0629 29.6462L20.8719 30.076L21.7857 30.4821ZM14.2143 30.4821L15.1281 30.076L14.9371 29.6462L14.4841 29.5192L14.2143 30.4821ZM18 39L17.0862 39.4061L18 41.4622L18.9138 39.4061L18 39ZM31 17C31 22.9601 26.9883 27.9858 21.5159 29.5192L22.0555 31.4451C28.3687 29.676 33 23.8801 33 17H31ZM18 4C25.1797 4 31 9.8203 31 17H33C33 8.71573 26.2843 2 18 2V4ZM5 17C5 9.8203 10.8203 4 18 4V2C9.71573 2 3 8.71573 3 17H5ZM14.4841 29.5192C9.01173 27.9858 5 22.9601 5 17H3C3 23.8801 7.63125 29.676 13.9445 31.4451L14.4841 29.5192ZM18.9138 38.5939L15.1281 30.076L13.3005 30.8883L17.0862 39.4061L18.9138 38.5939ZM20.8719 30.076L17.0862 38.5939L18.9138 39.4061L22.6995 30.8883L20.8719 30.076Z" fill="#161718" mask="url(#path-1-inside-1_23414_15743)"/>
<g clip-path="url(#clip0_23414_15743)">
<path d="M18 24.683C13.104 19.566 12.322 17.9 12.322 15.639C12.322 12.596 14.923 10.012 18 10.012C21.077 10.012 23.678 12.596 23.678 15.639C23.678 17.9 22.896 19.566 18 24.683ZM18 17.679C19.139 17.679 20.057 16.761 20.057 15.622C20.057 14.483 19.139 13.565 18 13.565C16.861 13.565 15.943 14.483 15.943 15.622C15.943 16.761 16.861 17.679 18 17.679Z" fill="#161718"/>
</g>
</g>
<defs>
<filter id="filter0_d_23414_15743" x="0" y="0" width="36" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_23414_15743"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23414_15743"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_23414_15743" result="shape"/>
</filter>
<clipPath id="clip0_23414_15743">
<rect width="20" height="20" fill="white" transform="translate(8 7)"/>
</clipPath>
</defs>
</svg>
`;

/**
 * Obtain svg string for google-maps marker
 * @param theme - Skoda Flow theme, can be obtained from useTheme() hook
 * @param marker - type of marker
 */
export const googleMapsMarkerIcon = (theme: Theme, marker?: 'selected' | 'unselected') => {
  if (marker === 'unselected') {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(theme.palette.mode === 'dark' ? markerUnselectedDark : markerUnselected)}`,
      scaledSize: { width: 36, height: 44 },
      anchor: { x: 36 / 2, y: 37 },
    };
  }

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(theme.palette.mode === 'dark' ? markerSelectedDark : markerSelected)}`,
    scaledSize: { width: 44, height: 52 },
    anchor: { x: 44 / 2, y: 45 },
  };
};

/**
 * Obtain legacy json style for google-maps
 * @param theme - Skoda Flow theme, can be obtained from useTheme() hook
 */
export const googleMapsStyle = (theme: Theme) => {
  if (theme.palette.mode === 'dark') {
    return [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#011e17',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#20262d',
          },
        ],
      },
      {
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9fa0',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#232425',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#9e9fa0',
          },
        ],
      },
      {
        featureType: 'administrative.country',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#c4c6c7',
          },
        ],
      },
      {
        featureType: 'administrative.locality',
        stylers: [
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#d8d8d8',
          },
        ],
      },
      {
        featureType: 'administrative.province',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#c4c6c7',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        stylers: [
          {
            color: '#011e17',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#649586',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#e4e4e4',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#1f5044',
          },
          {
            saturation: -70,
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9fa0',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#232425',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#3c3d3e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#8e8f90',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#b3842d',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#161718',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#000f0b',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#000000',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#8e8f90',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#161718',
          },
        ],
      },
    ];
  }

  return [
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#efefef',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels',
      stylers: [
        {
          color: '#7c7d7e',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#5a5b5c',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#5a5b5c',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      stylers: [
        {
          color: '#F1F1F1',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#cfe8e0',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7c7d7e',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffeeac',
        },
      ],
    },
    {
      featureType: 'transit.line',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#C4C6C7',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#E4E4E4',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'labels.icon',
      stylers: [
        {
          color: '#5a5b5c',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#5a5b5c',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#5a5b5c',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'water',
      stylers: [
        {
          color: '#bbe2fb',
        },
      ],
    },
  ];
};
